import { atom } from "jotai";

type jsonViewerType = {
    title: string;
    data: object;
}

const jsonViewerAtom = atom<jsonViewerType>({ title: "", data: {} });

export default jsonViewerAtom;
